const ENIndicatorHierarchy = {
	"Erro ao buscar itens da hierarquia": "Error on search hierarchy itens",
	"Erro ao atualizar hierarquia":"Error on update hierarchy",
	"Erro ao inserir itens na hierarquia":"Error on insert item in hierarchy",
	"Erro ao excluir item da hierarquia":"Error on delete item from hierarchy",
	"Selecione indicadores de nivel {{level}} para inserir na hierarquia":"Select indicators from {{level}} level to insert on hierarchy",
	"Inserir na hierarquia":"Insert in hierarchy",
	"Retirar da hierarquia":"Delete from hierarchy",
	"Não foi encontrado indicadores para esta hierarquia":"No indicators were found for this hierarchy",
	"Erro ao buscar indicadores":"Error on search indicators",
	"Inserir na hierarquia indicador de nivel estratégico":"Insert in hierarchy strategic level indicator",
	"Não foi encontrado indicadores para este nivel":"No indicators were found for this level"
};

export default ENIndicatorHierarchy;
